import kk from './kk.json'
import ru from './ru.json'

export const locales = {
  'ru-RU': [ru],
  'ru-KZ': [ru],
  'kk-KZ': [kk],
}
